<template>
	<div class="card">
		<div class="card__title mb-20">
			<c-title>
				{{ title }}
			</c-title>
		</div>
		<div class="card__content">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: () => '',
		},
	},
};
</script>

<style lang="scss">
	.card{
		display: flex;
		flex-direction: column;
		padding: 20px;
		background: #EDEDED;
		border-radius: 20px;
		text-align: left;
		align-items: flex-start;
	}
</style>
